import * as React from "react";
import { useLocation } from "react-router-dom";

export const ScrollSink: React.FC<{}> = () => {
  const cache = React.useRef<Record<string, boolean>>({});

  const location = useLocation<{
    scroll: boolean;
  }>();

  React.useEffect(() => {
    if (!location.key) {
      console.log("No location key found. Do nothing.");
      return;
    }

    if (cache.current[location.key]) {
      console.log("Popstate page. Do nothing.");
      return;
    }

    if (location.state?.scroll === false) {
      /*
        we can prevent scrolling on history.push by sending down state.scroll = false,
        this is used on tabbed navigation
      */
      return;
    }

    cache.current[location.key] = true;

    window.scrollTo(0, 0);
  }, [location.pathname, location.key, location.state, cache]);

  return null;
};
